const ThreeDotsLoader = () => {
  return (
    <div className="flex justify-center items-center w-full h-[400px]">
      <div className="flex items-center justify-center space-x-2">
        <div className="w-4 h-4 bg-sidebar-primary rounded-full animate-bounce delay-100"></div>
        <div className="w-4 h-4 bg-sidebar-primary rounded-full animate-bounce delay-200"></div>
        <div className="w-4 h-4 bg-sidebar-primary rounded-full animate-bounce delay-300"></div>
      </div>
    </div>
  );
};

export default ThreeDotsLoader;
